var EducationalContent = {
    launchEducationalContent: function (searchInput) {
        loader(1);
        $.ajax({
            type: "GET",
            async: true,
            data: { "launchInput": 'Healthwise', "searchInput": searchInput },
            url: baseURL + "/ConnectedApps/LaunchClient",
            dataType: "json",
            success: function (response) {
                loader(0);
                if (response.success) {
                    var popUp = window.open(response.url, (window.browserPopUpName || window.top.browserPopUpName), 'height=780,width=1550,toolbar=0,scrollbars=yes');
                    healthWiseWindow = popUp;
                    checkHealthiwisePopUpClosed(popUp, response.callId);
                }
                else {
                    $("#divHealthiwiseAuthenticationlMsg").show();
                    $("#divHWFailMsg").text(response.msg);
                    $("#CMModalPopupMaskMessage").show();
                }
            }
        });
    }
};

var HealthwiseService = {
    extractArticles: function (callId) {
        if (callId) {
            $.ajax({
                type: "GET",
                async: true,
                data: { callId: callId, userId: getMemberId().MemberId },
                url: baseURL + "/HealthWise/ExtractArticle" ,
                dataType: "json",
                success: function (response) {
                    if (response.StatusCode === 200 && response.PatientId.toString() === $('#selectPatientAccessed').val()) {
                        $("#healthArticleMsg").show();
                        $("#healthArticleSuccessfulMsg").text("Health Article(s) have been added successfully");

                        if ($('#careLiteratureGrid').is(":visible")) {
                            $("#careLiteratureGrid").data("kendoGrid").dataSource.page(1);
                        }
                        addActivityPopUp('Do you want to create an activity for education platform?');
                    }
                    else if (response.StatusCode === 500 || response.StatusCode === 404) {
                        $("#healthArticleSryErrorMsg").show();
                        $("#divHWErrorMsg").text("Something went wrong. Please try again.");
                    }
                    else {
                        //No logic
                    }
                }
            });
        }
    }
};

function checkHealthiwisePopUpClosed(healthiwisePopup,callId) {
    var MyPopup = setInterval(function () {
        if (healthiwisePopup !== undefined) {
            if (healthiwisePopup.closed) {
                setTimeout(() => {
                    $("#healthArticleMsg").hide();
                    $("#healthArticleSryErrorMsg").hide();
                    healthWiseWindow = null;
                    missedArticleIds = '';
                    HealthwiseService.extractArticles(callId);
                }, 1);
                clearInterval(MyPopup);
            }
        }
        else { clearInterval(MyPopup); }
    }, 1000);
}

function addActivityPopUp(message) {
    $('#divHealthiwiseAddActivity').CMNPopup({
        popUpHeader: "Create Activity",
        closeButton: '#BtnAddActivityNo',
    });
    $('#divMessage').AhsSetHtml(message);
    $('#divHealthiwiseAddActivity').off('click', '#BtnAddActivityYes').on('click', '#BtnAddActivityYes', function () {
        $('#divHealthiwiseAddActivity').hide();
    });
}
function oncloseHealthiwiseMsg(closeMsgID) {
    $("#CMModalPopupMaskMessage").hide();
    closeMsgID.parentElement.style.display = 'none';
}

